// Keep cloud documents portable: device-local paths never become another device's paths.
import type { MediaRef } from '../types';
export async function mapMedia(
  value: unknown,
  convert: (ref: MediaRef) => Promise<MediaRef>,
): Promise<unknown> {
  if (Array.isArray(value)) {
    const result = [];
    for (const item of value) result.push(await mapMedia(item, convert));
    return result;
  }
  if (!value || typeof value !== 'object') return value;
  const object = value as Record<string, unknown>;
  if (typeof object.uri === 'string') return convert(object as MediaRef);
  const result: Record<string, unknown> = {};
  for (const [key, item] of Object.entries(object))
    result[key] = await mapMedia(item, convert);
  return result;
}
